module.exports = __webpack_public_path__ + "static/media/sem_lactose.5415ad8b.png";